export interface ValueLine {
  label: string
  value: string
}

export const valueStack: ValueLine[] = [
  { label: 'The 6-Volume Core System', value: '$197' },
  { label: 'The 7 Strategic Bonuses', value: '$111' },
]

export const totalValue = '$308'
export const launchPrice = '$27'
